import { Http, Headers, Response } from '@angular/http';
import { Subject } from 'rxjs/Rx';
import { environment } from '../../environments/environment';

export class BaseService {

  private baseUrl = environment.baseUrl;

  protected _subject$: Subject<Array<any>>;

  constructor(protected http: Http) {
    this._subject$ = <Subject<Array<any>>>new Subject();
  }

  protected getBaseUrl(): string {
    return this.baseUrl;
  }

  protected get(route: string, excludeAuthorization?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.get(this.baseUrl + route, {headers: this.buildHeaders(excludeAuthorization)})
      .map(response => response.json()).subscribe(
        data => {
          resolve(data.data);
        },
        err => {
          reject(this.extractError(err));
        });
    });
  }

  protected delete(route: string, excludeAuthorization?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.delete(this.baseUrl + route, {headers: this.buildHeaders(excludeAuthorization)})
      .map(response => response.json()).subscribe(
        data => {
          resolve(data.data);
        },
        err => {
          reject(this.extractError(err));
        });
    });
  }

  protected post(route: string, payload: any, excludeAuthorization?: boolean, customToken?: string): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.post(this.baseUrl + route, payload, {headers: this.buildHeaders(excludeAuthorization, customToken)})
      .map(response => response.json()).subscribe(
        data => {
          resolve(data.data);
        },
        err => {
          reject(this.extractError(err));
        });
    });
  }

  private buildHeaders(excludeAuthorization?: boolean, customToken?: string): Headers {
    const headers = new Headers();
    if (excludeAuthorization) {
      return headers;
    }

    let token = customToken;
    if (!token) {
      token = sessionStorage.getItem('Authorization');
    }
    if (!token) {
      token = localStorage.getItem('Authorization');
    }
    if (!token) {
      return headers;
    }

    headers.set('Authorization', token);
    return headers;
  }

  private extractError(error: Response | any) {
    let message: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      message = body.message || JSON.stringify(body);
    }
    else {
      message = error.message ? error.message : error.toString();
    }

    return {
      message: message,
      code: error.status
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts